module.exports = __webpack_public_path__ + "static/media/ban-outline.12773a71.svg";